import GET from '../GET'
import config from "../config.json"
let get = new GET('events');

export const event = {
  getOne(id){
    return get.one(id);
  },
  getFilterEventsList(){
    return fetch(`${config.apiUrl}/events/` +
      `?display=[id,title,short_description,document,date_upd]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        const eventsWithValidData = d.eventss.filter(event =>
          event.date_upd
        );
        // Trier les événements par date_upd (ordre décroissant)
        const sortedEvents = eventsWithValidData.sort((a, b) =>
          new Date(b.date_upd) - new Date(a.date_upd)
        );

        return sortedEvents;
      })
  },
  getListParticipantParuser(data){
    return fetch(`${config.apiUrl}/participant/` +
       `?display=[id,name,active,id_events,status,id_customer]` +
       `&filter[id_customer]=[${data}]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.events_participants;
      })
  },
  getFilterEventsLimit() {
    return fetch(`${config.apiUrl}/events/` +
        `?display=[id,title,short_description,document,date_upd]` +
        `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      })
      .then(d => {
        const eventsWithValidData = d.eventss.filter(event =>
          event.date_upd
        );
        // Trier les événements par date_upd (ordre décroissant)
        const sortedEvents = eventsWithValidData.sort((a, b) =>
          new Date(b.date_upd) - new Date(a.date_upd)
        );
        // Tronquer la liste pour n'inclure que les 4 premiers événements
        const limitedEvents = sortedEvents.slice(0, 4);
  
        return limitedEvents;
      });
  },
  getFilterEventsSearchFetch(data){
    return fetch(`${config.apiUrl}/events/` +
       `?display=[id,title,short_description]` +
       `&filter[id]=[${data.idEvents}]` +
       `&filter[date_start]=[${data.startDate}]&filter[date_end]=[${data.endDate}]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.eventss;
      })
  },
  getListEventsParticipant(){
    return fetch(`${config.apiUrl}/participant/` +
      `?display=[id,name,active,id_events,id_customer]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.events_participants;
      })
  },
  async addParticipant(data) {
    let url = `${config.postRequest.url}addParticipants.php?` +
      `eventId=${data.id}` +
      `&title=${data.title}` +
      `&dateEnd=${data.dateEnd}` +
      `&dateStart=${data.dateStart}`;
  
    // Ajouter idOrganizer s'il n'est pas vide
    if (data.idOrganizer !== "") {
      url += `&idOrganizer=${data.idOrganizer}`;
    }
  
    // Ajouter le reste des paramètres
    url += `&name=${data.name}` +
      `&email=${data.email}` +
      `&message=${data.message}`;
  
    const fe = await fetch(url);
  
    if (!fe.ok) {
      throw new Error('Erreur backend');
    }
  
    return await fe.json();
  },
  getLisDocuments(){
    return fetch(`${config.apiUrl}/download/` +
      `?display=[id,name,document]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.events_downloads;
      })
  },
  getAssociationEventsDocuments(){
    return fetch(`${config.apiUrl}/events_assoc_download/` +
      `?display=[id,id_events,id_events_download]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.events_assoc_downloads;
      })
  },
  
}


// WEBPACK FOOTER //
// ./src/utils/events/index.js